export const productSources = [
    { id: 'GS1', name: 'GS1' },
    { id: 'KAUCJA', name: 'KAUCJA' },
    { id: 'CBDOK', name: 'CBDOK' },
    { id: 'MAASLOOP', name: 'MAASLOOP' },
];
